export const addInitialValues = {
  staffId: '',
  completeName: '',
};
